import styled from "styled-components";

export const ContainerSlider = styled.div`
  width: 80px;
  .slider {
    transform: rotate(-90deg);
    -webkit-appearance: none;
    border-radius: 5px;
    width: 260px;
    margin-left: -88px;
    border-radius: 50px;
    background: #f2f4f8;
    outline: none;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;
  }

  .slider:hover {
    opacity: 1;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #ececec;
    box-shadow: -6px 1px 4px 0px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .slider::-moz-range-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #ececec;
    box-shadow: -6px 1px 4px 0px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }
`;
